import { render, staticRenderFns } from "./imgUpload.vue?vue&type=template&id=5d9ed13c&scoped=true"
import script from "./imgUpload.vue?vue&type=script&lang=js"
export * from "./imgUpload.vue?vue&type=script&lang=js"
import style0 from "./imgUpload.vue?vue&type=style&index=0&id=5d9ed13c&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9ed13c",
  null
  
)

export default component.exports